import React, { Component } from "react";

import "./style.scss";
import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

import {Button} from '@learningblocks/exp-components/lib/Button';

// Icons
import IconCorrect from "./img/Correct-icon.svg";
import IconIncorrect from "./img/Incorrect-icon.svg";
import PopupIcon from "./img/Popup-icon.svg"
import close from "../../../img/close.svg"

export class TableQuestion extends Component {

  constructor(props) {
    super(props);

    this.state = {
      feedbackShown: false,
      feedbackCorrect: false,
      feedback: "Default",
      updated: false,
      tableData: this.props.tableData,
      dropDownOptions:[
        "1 μl Extracted DNA",
        "1 μl normal GENE X control DNA",
        "1 µL mutated GENE X control DNA",
        "1 μl DNase free water",
        "1 μl prokaryotic control DNA"
      ]
    }
  }

  numsOnly = text => {
    text = text.replace(/[^0-9.]/g, "")

    return text;
  };

  handleInputChange = (e, row, index) => {
    if (this.numsOnly(e.target.value) !== e.target.value) {
      e.target.setCustomValidity("Please input an integer");
      e.target.reportValidity();
    } else {
      e.target.setCustomValidity("");
    }

    let tableData = this.state.tableData;
    tableData.data[row][index] = this.numsOnly(e.target.value)

    this.setState({
      tableData: tableData,
      updated: true
    })

  };

  getFeedback = (row, index, value) => {

      let feedback = "";
      let correct = false;

      switch(row) {
        case 1: // Control 1 (normal GENE X, positive control)
          if(value === "1 μl extracted human DNA"){
            feedback = "You have selected a template DNA that will result in an unknown outcome. For a positive control you want a known outcome for comparison."
            correct = false;
          }
          if(value === "1 μl normal GENE X control DNA"){
            feedback = "You have selected a template DNA that contains <i>GENE X</i> and the outcome of amplifying <i>GENE X</i> is known. This is good for positive control."
            correct = true;
          }
          if(value === "1 µL mutated GENE X control DNA"){
            feedback = "You have selected a template DNA that contains <i>GENE X</i> and the outcome of amplifying <i>GENE X</i> is known. This is good for positive control but this tube is labeled homozygous normal positive control. ";
            correct = false;
          }
          if(value === "1 μl DNase free water"){
            feedback = "You have selected water as your template. This should not contain any nucleic acids to amplify. For a positive control you want a known positive outcome for comparison.";
            correct = false;
          }
          if(value === "1 μl prokaryotic control DNA"){
            feedback = "You have selected a template DNA that does not contain <i>GENE X</i>. For a positive control you want a known positive outcome for comparison.";
            correct = false;
          }
          break;
        case 2: // Control 2 (mutated GENE X, positive control)
          if(value === "1 μl extracted human DNA"){
            feedback = "You have selected a template DNA that will result in an unknown outcome. For a positive control you want a known outcome for comparison."
            correct = false;
          }
          if(value === "1 μl normal GENE X control DNA"){
            feedback = "You have selected a template DNA that contains <i>GENE X</i> and the outcome of amplifying <i>GENE X</i> is known. This is good for positive control but this tube is labeled homozygous mutated positive control."
            correct = false;
          }
          if(value === "1 µL mutated GENE X control DNA"){
            feedback = "You have selected a template DNA that contains <i>GENE X</i> and the outcome of amplifying <i>GENE X</i> is known. This is good for positive control.";
            correct = true;
          }
          if(value === "1 μl DNase free water"){
            feedback = "You have selected water as your template. This should not contain any nucleic acids to amplify. For a positive control you want a known positive outcome for comparison.";
            correct = false;
          }
          if(value === "1 μl prokaryotic control DNA"){
            feedback = "You have selected a template DNA that does not contain <i>GENE X</i>. For a positive control you want a known positive outcome for comparison.";
            correct = false;
          }
          break;

        case 3: // Control 3 (no template Negative Control)
          if(value === "1 μl extracted human DNA"){
            feedback = "You have selected a template DNA that will result in an unknown outcome.  For a negative control you want a reaction that should give you no outcome for comparison.";
            correct = false;
          }
          if(value === "1 μl normal GENE X control DNA"){
            feedback = "You have selected a template DNA that contains <i>GENE X</i> and the outcome of amplifying <i>GENE X</i> is known.  Amplifying this will result in a known positive result. A negative control produce no result by design. Choose a different template.";
            correct = false;
          }
          if(value === "1 µL mutated GENE X control DNA"){
            feedback = "You have selected a template DNA that contains <i>GENE X</i> and the outcome of amplifying <i>GENE X</i> is known.  Amplifying this will result in a known positive result. A negative control produce no result by design. Choose a different template.";
            correct = false;
          }
          if(value === "1 μl DNase free water"){
            feedback = "You have selected water as your template. This should not contain any nucleic acids to amplify. This will help determine if you have any contamination of DNA from your skin cells.";
            correct = true;
          }
          if(value === "1 μl prokaryotic control DNA"){
            feedback = "You have selected a template DNA. To make sure that there is no contamination from outside sources of DNA, choose an option that does not contain DNA.";
            correct = false;
          }
          break;

        case 4: // Control 4 (prokaryotic control DNA Negative Control)
          if(value === "1 μl extracted human DNA"){
            feedback = "You have selected a template DNA that will result in an unknown outcome.  For a negative control you want a reaction that should give you no outcome for comparison.";
            correct = false;
          }
          if(value === "1 μl normal GENE X control DNA"){
            feedback = "You have selected a template DNA that contains <i>GENE X</i> and the outcome of amplifying <i>GENE X</i> is known.  Amplifying this will result in a known positive result. A negative control produce no result by design. Choose a different template.";
            correct = false;
          }
          if(value === "1 µL mutated GENE X control DNA"){
            feedback = "You have selected a template DNA that contains <i>GENE X</i> and the outcome of amplifying <i>GENE X</i> is known.  Amplifying this will result in a known positive result. A negative control produce no result by design. Choose a different template.";
            correct = false;
          }
          if(value === "1 μl DNase free water"){
            feedback = "This should not contain any nucleic acids to amplify, however, the purpose of this control is to test the primers to determine if they are amplifying <i>GENE X</i> specifically. Choose a template that contains DNA but does not contain the <i>GENE X</i> region.";
            correct = false;
          }
          if(value === "1 μl prokaryotic control DNA"){
            feedback = "You have selected a template DNA that does not contain <i>GENE X</i>. This will help you determine if your primers are specifically amplifying only that <i>GENE X</i> region. ";
            correct = true;
          }
          break;
        default:
          feedback = "Default";
      }

      this.setState({
        feedback: feedback,
        feedbackCorrect: correct,
        feedbackShown: (feedback !== "Default")
      })

  }

  handleSelectChange = (e, row, index) => {

    let tableData = this.state.tableData;
    tableData.data[row][index] = e.target.value

    this.getFeedback(row, index, e.target.value)

    this.setState({
      tableData: tableData,
      updated: true
    })

  };

  handleSubmit = (e) => {
    //e.preventDefault();
    this.props.setTableQuestionData({
      tableData: this.state.tableData
    });
    this.setState({
      updated: false
    })
    // this.props.showModal({
    //   display: false
    // });
  };

  getContent = (content, headings) => {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: "32px"
      }}>
        <div style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: colors.navy1
        }}>
          {headings.map((heading, index) => {
            return (
              <div
                style={{
                  borderTopWidth: 1,
                  borderLeftWidth: 1,
                  borderBottomWidth: "1px",
                  borderColor: colors.navy4,
                  borderStyle: "solid",
                  flexBasis: 1,
                  flexGrow: 1,
                  flexShrink: 1,
                  borderRightWidth: index === headings.length - 1 ? "1px" : 0,
                }}
              >
                <p style={{
                  color: "white",
                  fontSize: "16px",
                  padding: 8,
                  margin: 0,
                  whiteSpace: "pre-wrap"
                }}>{heading}</p>
              </div>
            );
          })}
        </div>
        {content.map((row, rowIndex)=>{
          return(
            <div style={{
              display: "flex",
              flexDirection: "row",
              //backgroundColor: (rowIndex === 0)?"white":null
            }}>
            {row.map((item, itemIndex) => {
              return (
                <div
                  style={{
                    borderBottomWidth: "1px",
                    borderTopWidth: "1px",
                    borderLeftWidth: "1px",
                    borderColor: colors.navy4,
                    borderStyle: "solid",
                    marginBottom: -1,
                    flexBasis: 1,
                    flexGrow: 1,
                    flexShrink: 1,
                    backgroundColor: itemIndex === 0 ? colors.navy1 : null,
                    borderRightWidth: itemIndex === row.length - 1 ? "1px" : 0
                  }}
                >
                  {(itemIndex === 0 || itemIndex === 1)?(
                    <p style={{
                      fontSize: "16px",
                      padding: 8,
                      margin: 0,
                      color: itemIndex === 0 ? "white" : null
                    }}>{item}</p>
                  )
                  :(
                    <div className="input-group">
                      <input onChange={e => this.handleInputChange(e, rowIndex, itemIndex)} type="text" placeholder="Enter μl" id={"ProtocolTable_"+rowIndex+"_"+itemIndex} value={item}/>
                      <div className="input-group-append">
                        <span class="input-group-text">μl</span>
                      </div>
                    </div>
                  )
                  }
                </div>
              );
            })}
            </div>
          )
        })}
      </div>
    );
  };

  close = () => {
    this.setState({
      feedbackShown: false
    });
  };

  render() {
    return (
      <div className="modal-section TableQuestion" style={{ width: "calc(100% - 0px)", height: "650px", margin: "auto" }}>
        <div className="modal-header">
          <img src={PopupIcon} alt="Popup icon." style={{marginRight: "16px"}}/>
          <h2>Pop Up Question</h2>
        </div>

        <div className="modal-body">
          <div className="modal-inner">
            <p style={{whiteSpace: "pre-wrap"}}>
              The ratio of reagents is important and is based on the starting concentrations of each reagent and the total volume in the tube. To keep the concentrations consistent, the same volume of reaction will be used. DNase free water will be added to bring the volume to 25 μ.
              <br/><br/>
              Below are the volumes needed for a single reaction based on the materials we are using. You will want to create enough mastermix so that you can complete all of your reactions and have a little extra in case you make a mistake. Calculate the total volume of each reagent you will need to add to create a master mix for <b>6 reactions</b>.
              <br/><br/>
              Below are the volumes needed for a single reaction, based on the materials we are using. You will want to create enough master mix so that you can complete all of your reactions and have a little extra in case you make a mistake. Calculate the total volume of each reagent you will need to add to create a master mix for <b>6 reactions</b>.
            </p>
            {this.getContent(this.state.tableData.data, this.state.tableData.headings)}
            <div style={{
              display: (this.state.feedbackShown)?"flex":"none",
              flexDirection: "row",
              justifyContent: "center",
              background: this.state.feedbackCorrect?"rgba(132,190,96,0.1)":"rgba(237,52,49,0.1)",
              border: "2px solid "+(this.state.feedbackCorrect?colors.green1:colors.red1),
              borderRadius: "5px",
              marginTop: "16px",
              padding: "8px"
            }}>
              <div>
                <img alt="" src={(this.state.feedbackCorrect)?IconCorrect:IconIncorrect} />
              </div>
              <p style={{margin: "auto 8px", hyphens: "auto", flex: 1}}>
                {this.state.feedback}
              </p>
              <div
                aria-label="Close Button"
                tabIndex={0}
                className="close-feedback"
                onKeyDown={e => {
                  if (e.keyCode === 13 || e.keyCode === 32) this.close(e);
                }}
                onClick={this.close}
                style={{
                  margin: "auto"
                }}
              >
                <img
                  style={{
                    display: "inline-block",
                    top: "3px",
                    position: "relative"
                  }}
                  src={close}
                  alt="Close button"
                />
              </div>
            </div>
            <div style={{textAlign: "right", marginTop: "16px"}}>
              <Button disabled={!this.state.updated} className='submitProtocolTable' onClick={(e)=>this.handleSubmit(e)}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
